/* @flow strict */

import * as React from 'react';
import DataTable from 'react-data-table-component';
import { columns } from './tableHeaders/ticketType';
import { GET } from '/client/src/api';
import { EventDetailContainerContext } from '/client/src/contexts/EventDetailContainer';
import _ from 'lodash';

const customStyles = {
  headCells: {
    style: {
      fontWeight: 700,
      fontSize: '1rem'
    }
  }
};

type PropsType = {
  eventId: string,
  onHandleSelectRow: () => void,
  selectedRow: any
};

const TicketTypeBody = ({ eventId, onHandleSelectRow, selectedRow }: PropsType): React.Element<'div'> => {
  const [data, setData] = React.useState([]);
  const [pending, setPending] = React.useState(true);
  const [search, setSearch] = React.useState('');
  const context = React.useContext(EventDetailContainerContext);
  const tickets = context.eventDetail.tickets;
  const CustomLoader = (): React.Element<'div'> => (
    <div className='csspinner' style={{ width: '50px', height: '50px' }} />
  );
  const _setSearch = (e) => {
    setSearch(e.target.value);
  };

  let __data = data;

  if (__data && _.size(search)) {
    __data = _.filter(__data, (d: {}): any => {
      return (
        d.name && d.name.indexOf(search) > -1 ||
        d.price && d.price.toString().indexOf(search) > -1 ||
        d.sold_quantity && d.sold_quantity.toString().indexOf(search) > -1
      );
    });
  }

  const fetchData =  async () => {
    try {
      // eslint-disable-next-line
      const { result } = await GET(`/api/v1/1/statistics/events/${eventId}/ticket_checkin_status?event_schedule_id=${_.get(context, 'eventDetail.schedules[0].id', 0)}`);

      const _data = tickets;

      _.map(_data, (ticket: any, index: number) => {
        const resultData = _.find(result, (item: any): {} => {
          return item.id === ticket.id;
        });
        // eslint-disable-next-line

        if (!!resultData) _data[index].sold_quantity = resultData.sold_quantity;
      });

      setData(_data);
      setPending(false);
    } catch (e) {
      console.log(e);
      console.error('Cant get attendees');
      setPending(false);
    }
  };

  React.useEffect(() => {
    fetchData();
  }, [eventId]);

  return (
    <div className="panel-body" style={{ padding: '15px 0' }}>
      <div className="form-group">
        <div className="input-group event-search">
          <input
            className="form-control"
            style={{ textAlign: 'left' }}
            type="text"
            placeholder="search ticket type"
            value={search}
            onChange={_setSearch}
          />
          <span className="input-group-btn">
            <button
              className="btn btn-default btn-search"
              type="button"
            >
              <span className="icon icon-search" />
            </button>
          </span>
        </div>
      </div>

      <div style={{ position: 'relative', minHeight: '120px' }}>
        <div style={{ width: '100%', overflowX: 'auto', position: 'relative' }}>
          <DataTable
            columns={columns()}
            data={__data}
            customStyles={customStyles}
            highlightOnHover
            responsive
            striped
            fixedHeader
            noHeader
            progressPending={pending}
            progressComponent={<CustomLoader />}
            selectableRows
            onSelectedRowsChange={(selected: any) => {
              onHandleSelectRow(selected.selectedRows);
            }}
            selectableRowSelected={
              (row: {id: string}): boolean => !!selectedRow ? selectedRow.some((el: string): boolean => el === row.id) : false
            }
            sortIcon={(): React.Element<typeof React.Fragment> => {
              return (
                <>
                  <span className="-sort-desc" />
                  <span className="-sort-asc" />
                </>
              );
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default TicketTypeBody;
